import { render } from "./Base64Converter.vue?vue&type=template&id=2a5ba85f&scoped=true"
import script from "./Base64Converter.vue?vue&type=script&lang=js"
export * from "./Base64Converter.vue?vue&type=script&lang=js"

import "./Base64Converter.vue?vue&type=style&index=0&id=2a5ba85f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5ba85f"]])

export default __exports__